import { User } from 'lucide-react';
import { FC, useMemo } from 'react';

import NullComponent from '@/components/NullComponent.tsx';

import { DailyAppointment } from '@/models/appointment/Appointment.ts';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    appointment: DailyAppointment;
}

const AppointmentTypeIndicator: FC<Props> = ({ appointment }) => {
    const isMissingPatient = !appointment.patient;

    const color = useMemo((): string => {
        if (appointment.is_eterno_user) {
            return 'text-green-700';
        }

        return 'text-red-700';
    }, [appointment]);

    if (isMissingPatient) {
        return <NullComponent />;
    }

    return (
        <div className="absolute bottom-0 right-0 flex items-center justify-center p-0.5">
            <User className={cn('size-4', color)} />
        </div>
    );
};

export default AppointmentTypeIndicator;
